import React, { useEffect, useState } from 'react'
import {Box, Grid, GridItem,IconButton,  Tr,Button,TableContainer,Checkbox,Heading, Thead,Tbody, Th,  Td,  Table,Tab, TabList, TabPanel, TabPanels, Tabs,Flex,Text, Input, Spacer} from '@chakra-ui/react'
import NavBar from '../../../elements/NavBar'
import {useHistory} from 'react-router-dom'
import { useSelector } from 'react-redux'
import { bindActionCreators } from "redux";
import { ActionCreators } from "../../../../redux/actions";
import { connect } from "react-redux";
import CurrentRequey_data from './components/CurrentRequey_data.js'
import UpdatedRecovery_Data from './components/UpdatedRecovery_Data.js'
import CustomToast from '../../../elements/customToast.js'
import moment from "moment";
import NoData from '../../../elements/NoData.js'
import Pagination from '../../../elements/Pagination.js'
import Loader from '../../../elements/loader.js'
const tabNames = [
    {
        id: 1,
        name: 'Delayed Loan',
    },
    {
        id: 2,
        name: 'Recovery Data',
    }
]

function Requerydata(props) {
    const history = useHistory()
    const { addToast } = CustomToast()
    const adminState = useSelector((state) => state.adminState)
    const recovert_adminState =adminState?.Recovery_Data 
    const [inputValues,setInputValues]=useState("")
  const [filterData, setFilterData] = useState([]);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState(new Set()); // Tracks selected checkboxes
  const [storedValues, setStoredValues] = useState(""); // Stores values separately
    const [selectedTab, setSelectedTab] = useState(tabNames[0].name)
    const GetNpa_data =adminState?.getNpa_Data?.data?.data
    const Trigger_btn_Response =adminState?.getRecovery_Trigger_Data?.data
    const userData = adminState?.getUserByToken?.data?.data
    const userType = userData?.usertype
    const [currentPage, setCurrentPage] = useState(0);
    const PER_PAGE = 10;
    const offset = currentPage * PER_PAGE;
    const pageCount = Math.ceil(GetNpa_data?.length / PER_PAGE);
    const [selectAll, setSelectAll] = useState(false); // Track Select All state
    useEffect(() => {
        props.actions.getUserByTokenAction()
    }, [])
    useEffect(() => {
    if (selectedTab === "Delayed Loan") {
        props?.actions?.getNPADetailsAction()
    }
  }, [selectedTab]);
      const handleTabChange = (index) => {
        
        setSelectedTab(tabNames[index].name);
    }
      useEffect(() => {
        if (adminState?.getNpa_Data?.data?.success === true) {
      setFilterData(GetNpa_data);
    }
  }, [adminState?.getNpa_Data]);
  
  useEffect(() => {
    if (adminState?.getRecovery_Trigger_Data?.data?.success === true) {
    addToast({ message: Trigger_btn_Response?.message, status: 'success' })
    setStoredValues("")
    setSelectedCheckboxes(new Set()); 
    setSelectedTab(tabNames[1].name )
    }
  }, [adminState?.getRecovery_Trigger_Data]);

   const handleChange = (e) => {
        const { name, value } = e.target;
        setInputValues({...inputValues, [name]: value})
    }
    // const trigger_btn =()=>{
    //     if(storedValues){
    //         props?.actions?.getRecoveryTriggerDetailsAction({loan_ids:storedValues})
    //     }
    //     else{
    //         // addToast("Please Select Your Value")
    //   addToast({ message: 'Please Select Your Value', status: 'error' })

    //     }
    //   }
    const trigger_btn = () => {
        if (storedValues && storedValues.length > 0) {
          props?.actions?.getRecoveryTriggerDetailsAction({ loan_ids: storedValues });
        } else {
          addToast({ message: "Please Select Your Value", status: "error" });
        }
      };
  const handleChange_check = (value) => {
  
    setSelectedCheckboxes((prevState) => {
      const newSet = new Set(prevState);
      if (newSet.has(value)) {
        newSet.delete(value);
      } else {
        newSet.add(value);
      }
  
      // Convert Set to a string after update
      const newStoredValues = Array.from(newSet).join(", ");
  
      // Update storedValues in the same function
      setStoredValues(newStoredValues);
  
      return newSet;
    });
  };
  const handleSelectAll = () => {
    setSelectAll(!selectAll); // Toggle select all state
  
    setSelectedCheckboxes((prevState) => {
      const newSet = new Set(prevState);
  
      if (!selectAll) {
        // If selecting all, add all loan IDs on current page
        filterData.slice(offset, offset + PER_PAGE).forEach((item) => {
          newSet.add(item.loan_id);
        });
      } else {
        // If unselecting all, remove only the current page's loan IDs
        filterData.slice(offset, offset + PER_PAGE).forEach((item) => {
          newSet.delete(item.loan_id);
        });
      }
  
      return newSet;
    });
  
    setStoredValues(() => {
      if (!selectAll) {
        return filterData
          .slice(offset, offset + PER_PAGE)
          .map((item) => item.loan_id)
          .join(", ");
      } else {
        return ""; // Clear stored values when unselecting
      }
    });
  };
  
  const handleSearch1 = (e) => {
    const {value} = e.target
       setCurrentPage(0)
       if (value !== '') {
        const result = filterData.filter((item) => {
            console.log('ite111m',item)
          return (item?.loan_number?.toLowerCase().includes(value.toLowerCase()) ||  item?.first_name?.toLowerCase().includes(value.toLowerCase()) || item?.last_name?.toLowerCase().includes(value.toLowerCase())|| item?.middle_name?.toLowerCase().includes(value.toLowerCase())
          || item?.mobile?.toLowerCase().includes(value.toLowerCase()) || item?.cp_name?.toLowerCase().includes(value.toLowerCase()) || item?.loan_contract_number?.toLowerCase().includes(value.toLowerCase()) || item?.loan_amount?.toLowerCase().includes(value.toLowerCase())
          || item?.recovery_amount?.toLowerCase().includes(value.toLowerCase()) || String(item?.total_outstanding_dues || '').toLowerCase().includes(String(value || '').toLowerCase()) || String(item?.tenure || '').toLowerCase().includes(String(value || '').toLowerCase())
          || String(item?.days_overdue || '').toLowerCase().includes(String(value || '').toLowerCase())
        )
        })
        setFilterData(result)        
      } else {
        setFilterData(GetNpa_data)
      }
    };
    const handlePageClick = ({ selected: selectedPage }) => {
        console.log("selecte11d",selectedPage)
        setSelectAll(false)
        setSelectedCheckboxes(new Set())
        setCurrentPage(selectedPage);
      };
  return (
    <Box className='dashboard_box bg_shadow'>
        <Grid className="main_grid_container align-items-center">
            <GridItem colSpan={8}>
                <Heading as="h2" className='font-poppins page_heading'> Recovery Dashboard</Heading>
            </GridItem>
            <GridItem colSpan={4}>
                <NavBar data={userData} isAdmin />
            </GridItem>
        </Grid>
        <Box mt={5}>
            {/* <Tabs className='tabs_container' onChange={handleTabChange}> */}
            <Tabs
    className='tabs_container'
    index={tabNames.findIndex(tab => tab.name === selectedTab)} // 🔹 Ensures the correct tab is active
    onChange={handleTabChange}
>
                <TabList className='tabs_list'>
                    {tabNames?.map((item, index) => {
                        return (
                            <Tab key={index}>{item.name}</Tab>
                        )
                    })}
                </TabList>
                <TabPanels>
                    {tabNames.map((item, index) => {
                        return (
                            <TabPanel key={index} className='tab_panel'>
                                {item.name === 'Delayed Loan' &&
                                    <>
                                    {recovert_adminState?.loading  && (
                                        <div>
                                          <Loader />
                                        </div>
                                      )}
                                    <Box mt={1}>
                                      <Box className="search_box">
                                        <Input
                                          type="text"
                                          size="md"
                                          name="search"
                                          placeholder="Search"
                                          onChange={handleSearch1}
                                          className="input_box font-poppins"
                                        />
                                      </Box>
                                      <>
                                      {filterData?.length > 0 ? (
                                          <Box mt={2} className="custom_table_wrapper custom_table_wrapper2">
                                            <TableContainer>
                                              <Table variant="simple">
                                                <Thead>
                                                  <Tr>
                                                  <Th ml={3}>
                                                    <Checkbox isChecked={selectAll} onChange={handleSelectAll}  />
                                                  {' '} {' '} Select All
                                                    </Th>
                                                    {/* <Th style={{marginRight:"30px"}}>S.No.</Th> */}
                                                    <Th>Days Overdue</Th>
                                                    <Th>Mobile</Th>
                                                    <Th>Name</Th>
                                                    <Th>Channel Partner Name</Th>
                                                    <Th>Total Outstanding Due</Th>
                                                    <Th>Loan Details</Th>
                                                    <Th>Loan Contract</Th>
                                                    <Th>Loan Disbursed Date</Th>
                                                    <Th>Loan EMI Date</Th>
                                                    <Th>Loan Amount</Th>
                                                    <Th>Tenure(Days)</Th>
                                                  </Tr>
                                                </Thead>
                                                <Tbody>
                                                  {filterData
                                                    ?.slice(offset, offset + PER_PAGE)
                                                    ?.map((item, index) => {
                                                      const serialNumber = offset + index + 1;
                                                      return (
                                                        <Tr key={index}>
                                                            {/* <Td>select All </Td> */}
                                                          <Td>
                                                            <Text className="font-poppins table_text" style={{marginRight:"30px"}}>
                                                              {serialNumber}
                                                            </Text>
                                                             <Checkbox  isChecked={selectedCheckboxes.has(item?.loan_id)} onChange={()=>handleChange_check(item?.loan_id)}/>
                                                          </Td>
                                                          <Td>
                                                            <Text className="font-poppins table_text">
                                                              {item?.days_overdue ? item?.days_overdue : "NA"}
                                                            </Text>
                                                          </Td> 
                                                       
                                                          <Td>
                                                            <Text className="font-poppins table_text">
                                                              {item?.mobile ? item?.mobile : "NA"}
                                                            </Text>
                                                          </Td>
                                                          <Td>
                                                            <Text className="font-poppins table_text">
                                                              {item?.first_name} {item?.last_name} {item?.middle_name}
                                                            </Text>
                                                          </Td>
                                                          <Td>
                                                            <Text className="font-poppins table_text">
                                                              {item?.cp_name ? item?.cp_name : "NA"}
                                                            </Text>
                                                          </Td>
                                                          <Td>
                                                            <Text className="font-poppins  gray_text">
                                                              {item?.total_outstanding_dues ? item?.total_outstanding_dues : "NA"}
                                                            </Text>
                                                            </Td>
                                                            <Td>
                              
                                                              <Text className="font-poppins table_text">
                                                                {item?.loan_number ? item?.loan_number : "NA"}
                                                              </Text>
                                                            </Td>
                                                         
                                                          <Td>
                                                            <Text className="font-poppins table_text">
                                                              {item?.loan_contract_number
                                                                ? item?.loan_contract_number
                                                                : "Not Assigned"}
                                                            </Text>
                                                          </Td>
                                                          <Td>
                                                            <Text className="font-poppins table_text">
                                                              {item?.disbursed_date
                                                                ? moment(item?.disbursed_date).format(
                                                                  "DD-MMM-YYYY"
                                                                )
                                                                : "Not Available"}
                                                            </Text>
                                                          </Td>
                                                          <Td>
                                                            <Text className="font-poppins table_text">
                                                              {item?.emi_date
                                                                ? moment(item?.emi_date).format("DD-MMM-YYYY")
                                                                : "Not Available"}
                                                            </Text>
                                                          </Td>
                                                          <Td>
                                                            <Text className="font-poppins table_text">
                                                              {item?.loan_amount ? item?.loan_amount : "Not Available"}
                                                            </Text>
                                                          </Td>
                                                          <Td>
                                                            <Text className="font-poppins table_text">
                                                              {item?.tenure ? item?.tenure : "Not Available"}
                                                            </Text>
                                                          </Td>
                                                        </Tr>
                                                      );
                                                    })}
                                                </Tbody>
                                              
                                              </Table>
                                            </TableContainer>
                                            <Button   className="btn_theme font-poppins" onClick={()=>trigger_btn()} mt={4} ml={5} mb={5}
                                              style={{color:"white"}}>Send For Recovery</Button>
                                            <Pagination
                                              pageCount={pageCount}
                                              handlePageClick={handlePageClick}
                                            />
                                          </Box>
                                      ) : (
                                        <NoData title="No Record Found" />
                                      )}
                                      </>
                                    </Box>
                                    
                                  </>
                                }
                                {item.name === 'Recovery Data' &&
                                    <UpdatedRecovery_Data
                                        tabSelected={selectedTab}
                                        inputValues={inputValues}
                                        handleChange={handleChange}
                                        // handleVerify={handleVerify}
                                        storedValues={storedValues}
                                        setStoredValues={setStoredValues}
                                        selectedCheckboxes={selectedCheckboxes}
                                    />
                                }
                            </TabPanel>
                        )
                    })}
                </TabPanels>
            </Tabs>
        </Box>

    
    </Box>
  )
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(ActionCreators, dispatch),
  });
  
  export default connect(null, mapDispatchToProps)(Requerydata);
  